/*
 * CARB'ON — tri personnalisé des collections par hauteur de jante et largeur interne.
 *
 * Shopify ne sait nativement trier une collection que par prix, titre, date ou
 * best-seller. Pour "Hauteur de jante" et "Largeur interne" (issues de nos
 * metafields custom.hauteur_jante_mm / custom.largeur_interne_mm), on
 * intercepte le <select name="sort_by"> avant que le composant natif
 * (facet-filters-form, voir facets.js) ne parte chercher une page triée côté
 * serveur, et on réordonne nous-mêmes les cartes déjà affichées à partir des
 * attributs data-height-mm / data-width-mm posés sur chaque <li class="grid__item">
 * (voir sections/main-collection-product-grid.liquid).
 *
 * Limite connue : le tri ne s'applique qu'aux produits déjà chargés sur la
 * page (pagination Dawn par défaut : 16 produits). Largement suffisant tant
 * que les collections restent sous ce seuil.
 */
(function () {
  var CUSTOM_SORTS = {
    'height-ascending': { attr: 'data-height-mm', dir: 1 },
    'height-descending': { attr: 'data-height-mm', dir: -1 },
    'width-ascending': { attr: 'data-width-mm', dir: 1 },
    'width-descending': { attr: 'data-width-mm', dir: -1 },
  };

  var activeCustomSort = null;

  function sortGrid(sortValue) {
    var config = CUSTOM_SORTS[sortValue];
    if (!config) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > li.grid__item'));
    if (!items.length) return;

    items.sort(function (a, b) {
      var va = parseFloat(a.getAttribute(config.attr));
      var vb = parseFloat(b.getAttribute(config.attr));
      var na = isNaN(va) ? Infinity : va;
      var nb = isNaN(vb) ? Infinity : vb;
      if (na === nb) return 0;
      return na < nb ? -config.dir : config.dir;
    });

    items.forEach(function (item) {
      grid.appendChild(item);
    });
  }

  function syncSortSelects(value) {
    document.querySelectorAll('select[name="sort_by"]').forEach(function (select) {
      if (select.value !== value) select.value = value;
    });
  }

  document.addEventListener(
    'input',
    function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('select[name="sort_by"]')) return;

      var value = target.value;
      if (CUSTOM_SORTS[value]) {
        event.preventDefault();
        event.stopPropagation();
        activeCustomSort = value;
        syncSortSelects(value);
        sortGrid(value);
      } else {
        activeCustomSort = null;
      }
    },
    true,
  );

  function patchRenderProductGridContainer() {
    var FacetFiltersForm = window.customElements && window.customElements.get('facet-filters-form');
    if (!FacetFiltersForm || FacetFiltersForm.__carbCustomSortPatched) return;

    var original = FacetFiltersForm.renderProductGridContainer;
    FacetFiltersForm.renderProductGridContainer = function (html) {
      original.call(this, html);
      if (activeCustomSort) sortGrid(activeCustomSort);
    };
    FacetFiltersForm.__carbCustomSortPatched = true;
  }

  if (window.customElements && window.customElements.get('facet-filters-form')) {
    patchRenderProductGridContainer();
  } else if (window.customElements) {
    window.customElements.whenDefined('facet-filters-form').then(patchRenderProductGridContainer);
  }
})();
